const createModel = () => {
  let DOMEl: HTMLElement | null = null;

  function hide() {
    DOMEl = document.getElementById('quidget');
    if (!DOMEl) {
      console.error('Quidget element not found (hide)');
      return;
    }
    DOMEl.style.display = 'none';
  }
  function show() {
    if (!DOMEl) {
      console.error('Quidget element not found (show)');
      return;
    }
    DOMEl.style.display = '';
  }
  return {
    hide,
    show,
  };
};

export const quidget = createModel();
